module.exports = __webpack_public_path__ + "static/media/newlogo.d1ab3b27.png";